import { createContext } from 'react';

import {
  modalInitializedKey,
  ModalContextValue,
  managerInitializedKey,
  ModalManagerContextValue
} from './Modal.types';

const initialMethods = {
  update: () => {},
  dismiss: () => {},
  activate: () => {},
  minimize: () => {},
  maximize: () => {},
  dock: () => {},
  unmount: () => {}
};

export const initialModalContext: ModalContextValue = {
  alert: false,
  dismissible: true,
  minimizable: false,
  maximizable: false,
  dockable: false,
  defaultMinimized: false,
  unmountWhenMinimized: true,
  state: 'open',
  top: false,
  [modalInitializedKey]: false,
  ...initialMethods
};

export const ModalContext = createContext<ModalContextValue>(initialModalContext);

export const ModalManagerContext = createContext<ModalManagerContextValue>({
  create: () => initialMethods,
  ModalContext,
  [managerInitializedKey]: false
});
